import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../../style/theme';
const {Text, Paragraph} = Typography;
const Content = Layout;

const Cinco = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Paragraph className='Title4' style={{color: appColors['ColorX'], marginTop: '3vh'}}><b>Unfair Advantage</b></Paragraph>
        <Text className='BaseText2' style={{marginTop: '0%'}}>The implementation of synthetic biology in the device with a Point of Care, rapid assay instead of the traditional diagnostics will give competitive advantages in the market due to the use of <b>aptamers instead of antibodies.</b> These have equal or better specificity and affinity than that of monoclonal antibodies and have <b>low production cost, long storage time at room temperature without falling into degradation, is easy to scale up and their production time is short </b> which would be an advantage for the lack of transportation infrastructure that is managed in Mexico [6] (Check Wet Lab and Dry Lab Section.)</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '60%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-27-5.jpeg'/>
          <p><b> Fig. 6.5</b>Complementary image of the <q>Unfair Advantage</q> section in the Business Model Canva  An aptamer for one of the biomarkers we are using is shown.</p>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Cinco;
